import {
  Divider,
  Group,
  GroupProps,
  MantineSpacing,
  Stack,
  Text,
  Title,
  TitleOrder,
} from "@mantine/core"
import { ReactElement, ReactNode } from "react"

export type SectionHeaderProps = {
  title?: ReactElement | string
  subtitle?: string
  mainCta?: ReactNode
  divider?: boolean
  justify?: "start" | "end" | "center" | "space-between" | "space-around"
  order?: TitleOrder
  titleFw?: number
  gap?: MantineSpacing
} & Omit<GroupProps, "title">

export const SectionHeader = ({
  title,
  mainCta,
  subtitle,
  divider,
  justify = "space-between",
  order = 3,
  titleFw = 700,
  gap = "xs",
  ...props
}: SectionHeaderProps) => {
  const renderTitle =
    typeof title === "string" ? (
      <Title order={order} fw={titleFw}>
        {title}
      </Title>
    ) : (
      title
    )

  return (
    <Group justify={justify} {...props}>
      <Stack gap={gap}>
        {renderTitle}
        {subtitle && <Text>{subtitle}</Text>}
      </Stack>
      {mainCta}
      {divider && <Divider w="100%" />}
    </Group>
  )
}
